<!-- 

	Was macht diese Componente?
	Wofür ist die Compoente da?
	
	Welche $props gibt es?
	
	Beispiel Code:
		<Dummy></Dummy>
	
	2019-06-08	init

-->

<template>
	<div class="CvSheet maxWidth maxWidth--page background background--white" :class="elmClasses">
		<div class="CvSheet__inner">
			
			<div class="CvSheet__header background background--lightGrey">
				<div class="CvSheet__title flex flex--spaceBetween vhSpace vhSpace--medium font font--sizeBig">
					<span>{{app.currentFilename}}</span>
					<a @click="app.reset()">×</a>
				</div>
				<div class="flex hSpace relative">
					<div class="CvSheet__tabSpacerBefore"></div>
					<div class="CvSheet__tabs">
						<div class="CvSheet__tabsTrack" :style="tabsTrackStyles">
							<a 	class="CvSheet__tab"
								:class="{
									'CvSheet__tab--isActive'  : tabIndex === tabsHeader.currentActiveTabIndex,
									'CvSheet__tab--isInactive': tabIndex !== tabsHeader.currentActiveTabIndex,
									'CvSheet__tab--isValid'   : tab.isValid,
									'CvSheet__tab--isInvalid' : !tab.isValid,
									'CvSheet__tab--isHidden'  : (app.showErrorsOnly && tab.isValid),
								}"
							 	@click="doActivateTab( tabIndex )"
								v-for="(tab, tabIndex) in tabs" :key="tabIndex">
								<span class="CvSheet__tabLabel">{{tabIndex+1}}</span>
								<a    class="CvSheet__tabRemoveBtn" @click="removeDatasetRow( tabIndex )" title="Lösche Tab" v-if="tabs.length > 1"></a>
							</a>
							<!--
							<div class="CvSheet__tabSpacer"></div>
							-->
						</div>
					</div>
					<div class="CvSheet__tabsNav" v-if="tabs.length">
						<a class="CvSheet__tabsNavBtn CvSheet__tabsNavBtn--appendTab" @click="appendDatasetRow()" title="Tab hinzufügen"></a>								
						<a class="CvSheet__tabsNavBtn CvSheet__tabsNavBtn--gotoPrevPage" @click="gotoTabsPage(-1)" :class="{'CvSheet__tabsNavBtn--isDisabled' : isFirstTabsPage }">◀</a>
						<a class="CvSheet__tabsNavBtn CvSheet__tabsNavBtn--gotoNextPage" @click="gotoTabsPage(1)"  :class="{'CvSheet__tabsNavBtn--isDisabled' : isLastTabsPage }">▶</a> 
					</div>
					<div class="CvSheet__tabSpacerAfter"></div>
				</div>
			</div>
			
			<div class="CvSheet__body vSpace XXXvSpace--medium">
				<!-- no valid data message -->
				<div class="hSpace hSpace--medium color color--darkRed" v-if="!tabs.length">
					<br/>
					<br/>
					Dieses Dokument enthält keine Daten.
				</div>
				
				<div class="CvSheet__datasetRow flex hSpace hSpace--medium" 
					 v-for="(dataset, datasetIndex) in _.get(activeDataset, 'cells')" 
					 :key="datasetIndex"
					 :class="{
						 'CvSheet__datasetRow--isHidden'  : (app.showErrorsOnly && dataset.isValid),
						 'CvSheet__datasetRow--isValid'   : dataset.isValid,
						 'CvSheet__datasetRow--isInvalid' : !dataset.isValid,
					 }">
					 	<div class="CvSheet__datasetRowLeft">
							<div class="CvSheet__datasetLabel vSpace vSpace--default font font--sizeSmall">
								{{dataset.key}}
							</div>
							<div class="CvSheet__datasetFormElm">
								<!-- thesauriRules werden als select abgebildet -->
								<template v-if="thesauriRules.includes( dataset.rule )">
									<CvSelect 
										@input="app.doChangeInputDatasetAndRevalidate($event, tabsHeader.currentActiveTabIndex, datasetIndex, dataset)" 
										:rule="dataset.rule" 
										:value="dataset.value"
									></CvSelect>
								</template>
								<!-- manche rules werden als textarea abgebildet -->
								<template v-else-if="isGuiTextarea( dataset )">
									<!-- 
									{{app.selectedScheme}} • {{dataset.key}} • {{isGuiTextarea( dataset )}} 
									-->
									<CvTextarea 
										@input="app.doChangeInputDatasetAndRevalidate($event, tabsHeader.currentActiveTabIndex, datasetIndex, dataset)" 
										XXXrule="dataset.rule" 
										:value="dataset.value"
									></CvTextarea>
								</template>
								<!-- alle anderen Werte werden als input abgebildet -->
								<template v-else>
									<CvInput 
										@input="app.doChangeInputDatasetAndRevalidate($event, tabsHeader.currentActiveTabIndex, datasetIndex, dataset)" 
										XXXrule="dataset.rule" 
										:value="dataset.value"
									></CvInput>
								</template>
							</div>
						</div>
						<div class="CvSheet__datasetRowRight" v-if="!dataset.isValid">
							<div class="CvSheet__errorMsg font font--sizeSmall color--darkRed vSpace vSpace--default">
								<div class="CvSheet__errorMsgTitle font font--bold">
									{{ getRuleErrorMessage( dataset.rule )[0] }}
									<br/>
								</div>
								<div class="CvSheet__errorMsgText" v-if="getRuleErrorMessage( dataset.rule )[1]">
									Beispiel: {{ getRuleErrorMessage( dataset.rule )[1] }}
								</div>
							</div>
						</div>
				</div>
				<br /><br />
				
				<div class="CvSheet__debug grid grid--cols-2" v-if="app.isDevEnv">
					<pre name="app.inputData">{{app.inputData}}</pre>
					<pre name="app.outputData">{{app.outputData}}</pre>					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import { EventBus } from '@/event-bus.js'
	import CvSelect from '@/components/CvSelect.vue'
	import CvTextarea from '@/components/CvTextarea.vue'
	import CvInput from '@/components/CvInput.vue'
	
	
	export default {
		name: 'CvSheet',
		components: {
			CvSelect,
			CvTextarea,
			CvInput,
		},
		mixins: [],
		props: {
			//imageObject: [Object, Boolean],
			//text: [String],
		},
		data() {
			return {
				tabsHeader : {
					currentPageIndex      : 0,
					tabsPerPage           : 10,
					currentActiveTabIndex : 0,
				},
				thesauriRules : [ // diese regeln mit einem <select> dargestellt
					'classificationThes',
					'formPlanumThes',
					'formProfilThes',
					'DateThes',
					'MaterialThes',
					'VorgangsThes',
					'CategoryThes',
					'ProbenThes',
					'FormProfilThes',
					'classificationThes_v2',
					'DateThes_v2',
					'MaterialThes_v2',
					'VorgangsThes_v2',
					'CategoryThes_v2',
					'ProbenThes_v2',					
					'PartiThes',
					'PartiThes_v2',
					'warenartThes',
					'warenartThes_v2',
					/*
					*/
				],
				textareaRules : [ // diese regeln werden als textareas dargestellt
					'Planumsbeschreibung v3---Beschreibung',
					'Profilliste v3---Beschreibung',
					'Profilbeschreibung v3---Beschreibung',
				],
			}
		},
		watch: {
			'tabsHeader.currentActiveTabIndex': { 
				handler: function( to, from ) {
					this.app.currentDatasetIndex = to
				},
				deep: true,
			},
			'app.currentFilename': { // reset tabs if doc changes
				handler: function( to, from ) {
					this.tabsHeader.currentPageIndex = 0
					this.tabsHeader.currentActiveTabIndex = 0
				},
				deep: true,
			},
			'app.outputData.countErrors': { // reset tabs if doc changes
				handler: function( to, from ) {
					//console.log('to:', to)
					//if( to === 0 ) this.app.showErrorsOnly = false
				},
				deep: true,
			},
			'app.showErrorsOnly': { // make sure that there is a visible active tab
				handler: function( to, from ) {
					if( to ){
						const currentActiveTabIndex = this.tabsHeader.currentActiveTabIndex
						const activeTabIsVisible    = !this.tabs[currentActiveTabIndex].isValid
						let firstInvalidTabIndex    = -1
						
						this.tabs.forEach((item, index)=>{
							console.log(index, item.isValid)
							if( !item.isValid && firstInvalidTabIndex < 0 ) firstInvalidTabIndex = index
						})
						
						console.log('showErrorsOnly:', to)
						console.log('currentActiveTabIndex:', currentActiveTabIndex)
						console.log('activeTabIsVisible:', activeTabIsVisible)
						console.log('firstInvalidTabIndex:', firstInvalidTabIndex)
						
						// wenn es keine sichtbaren aktiven tab gab wird hier der erste invalide verwendet
						if( !activeTabIsVisible ){
							this.tabsHeader.currentActiveTabIndex = firstInvalidTabIndex
						}
					}
				},
				deep: true,
			},
		},
		computed: {
			app() {
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []
				
				//classes.push('new_class')
				
				return classes
			},
			tabsTrackStyles(){
				const styles = {}
				
				styles.transform = 'translateX(-' + (this.tabsHeader.currentPageIndex * 100) + '%)'
				
				return styles
			},
			isFirstTabsPage(){
				if( this.tabsHeader.currentPageIndex < 1 ){
					return true
				}else{
					return false
				}
			},
			isLastTabsPage(){
				if( (this.tabsHeader.currentPageIndex + 1) * this.tabsHeader.tabsPerPage >= this.app.outputData.bodyRows.length ){
					return true
				}else{
					return false
				}
			},
			activeDataset(){
				return this.app.outputData.bodyRows[ this.tabsHeader.currentActiveTabIndex ]
			},
			tabs(){
				const tabs     = []
				const datasets = this.app.outputData.bodyRows
				
				this._.forEach( datasets, dataset=>{
					tabs.push({
						isValid : dataset.isValid
					})
				})
				
				return tabs
			},
		},
		methods: {
			isDatasetRowVisible( dataset ){
				const isValid = dataset.isValid
				
				if( this.app.showErrorsOnly ){					
					return !isValid
				}else{
					return true					
				}
			},
			isGuiTextarea( dataset, doLog = false ){
				const currentRule   = this.app.selectedScheme + '---' + dataset.key
				const isGuiTextarea = this.textareaRules.includes( currentRule )
				
				if( doLog ){
					console.group('CvSheet • isGuiTextarea()')
					console.log('dataset:', dataset)
					console.log('currentRule:', currentRule)
					console.log('isGuiTextarea:', isGuiTextarea)
					console.groupEnd()
				}
				
				return isGuiTextarea
			},
			gotoTabsPage( newIndex ){
				this.tabsHeader.currentPageIndex = this.tabsHeader.currentPageIndex + newIndex
			},
			doActivateTab( tabIndex ){
				this.tabsHeader.currentActiveTabIndex = tabIndex
			},			
			getRuleErrorMessage( ruleName ){
				const msgTitle = this.app.rules[ruleName].msgTitle
				const msgText = this.app.rules[ruleName].msgText
				const testFor = this.app.rules[ruleName].testFor
				return [
					msgTitle,
					msgText,
					testFor,
				]
			},
			removeDatasetRow( rowIndex, doLog = false ){
				const outputData     = this.app.outputData
				const countRows      = this.app.outputData.bodyRows.length
				const canRemove      = ( countRows > 1 ) ? true : false
				const activeTabIndex = this.tabsHeader.currentActiveTabIndex
				
				if( canRemove ){
					this.app.outputData.bodyRows.splice( rowIndex, 1 )
				}
				if( activeTabIndex > countRows-1 ){
					//this.tabsHeader.currentActiveTabIndex = countRows-1
				}
				
				if( doLog ){
					console.group('CvSheet • removeDatasetRow()')
					console.log('rowIndex:', rowIndex)
					console.log('outputData:', outputData)
					console.log('countRows:', countRows)
					console.log('canRemove:', canRemove)
					console.log('activeTabIndex:', activeTabIndex)
					console.groupEnd()
				}
				
				// wenn es nach dem entfernen der row keine aktive gibt, 
				// wird hier die letzte row als active gesetzt
				if( !this.app.outputData.bodyRows[activeTabIndex] ){
					//console.log('set newActiveTabIndex:', newActiveTabIndex)
					
					// short delay needed
					const newActiveTabIndex = this.app.outputData.bodyRows.length-1
					setTimeout( ()=>{ this.tabsHeader.currentActiveTabIndex = newActiveTabIndex }, 50 )
				}
				
				// revalidate doc nachdem eine row entfernt wurde
				this.app.doValidateOutputData()
				
			},
			appendDatasetRow( doLog = false ){
				let newRow = this._.cloneDeep( this.app.outputData.bodyRows[0] )
				
				const currentPageIndex      = this.tabsHeader.currentPageIndex
				const tabsPerPage           = this.tabsHeader.tabsPerPage
				const currentActiveTabIndex = this.tabsHeader.currentActiveTabIndex
				
				// set all values to ''
				newRow.cells.forEach( (v, k)=>{ v.value = '' })
				
				// append new row
				this.app.outputData.bodyRows.push( newRow )
				
				// nachdem die neue row appended wurde wird der letzte tab (der neue)
				// aktiv gesetzt
				const newActiveTabIndex = this.app.outputData.bodyRows.length-1
				setTimeout( ()=>{ this.tabsHeader.currentActiveTabIndex = newActiveTabIndex }, 50 )
				
				// wenn sich der neue tab auf einer neuen tabs page befindet
				// wird diese hier gesetzt
				this.tabsHeader.currentPageIndex = Math.ceil( (newActiveTabIndex+1) / tabsPerPage ) - 1
				
				// revalidate doc nachdem eine row hinzugefügt wurde
				this.app.doValidateOutputData()
				
				if( doLog ){
					console.group('CvSheet • appendDatasetRow()')
					console.log('currentPageIndex:', currentPageIndex)
					console.log('newRow:', newRow)
					console.log('newActiveTabIndex:', newActiveTabIndex)
					console.log('tabsPerPage:', tabsPerPage)
					console.log('check:', (newActiveTabIndex+1) / (tabsPerPage) )
					console.log('ceil:', Math.ceil( (newActiveTabIndex+1) / tabsPerPage ) )
					console.groupEnd()	
				}
			},
		},
		created() {},
		mounted() {
			EventBus.$on('changeCurrentDatasetIndex', (newIndex)=>{
				this.tabsHeader.currentActiveTabIndex = newIndex
			})
		},
		destroyed () {},
	}
</script>

<style lang="less">
	@import (reference) "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";
	
	.CvSheet {
		display: flex;
		flex-direction: row;
		flex-grow: 1;
		width: 100%;
		margin: 0 auto;
		overflow: hidden;
		
		border: 1px solid fade( black, 40 );
		box-shadow: 0 0 1em 0em fade( black, 10 );
		border-top-left-radius: 0.25em;
		border-top-right-radius: 0.25em;
	}
	.CvSheet__inner {
		flex-grow: 1;
		max-width: 100%;
	}
	
	@tabsActiveBorderColor   : lighten( black, 55 );
	@tabsInActiveBorderColor : lighten( black, 75 );
	
	.CvSheet__header {}
	.CvSheet__title {
		span {
			opacity: 0.75;
			text-overflow: ellipsis;
			overflow: hidden;
			max-width: calc( 100% - 1em );
		}
	}
	.CvSheet__debug {
		[showBorders2] & { display: grid; }
		display: none;
		
		& > * {
			min-width: 0;
			min-height: 0;
		}
	}
	
	.CvSheet__tabSpacerBefore {
		border-bottom: 1px solid @tabsActiveBorderColor;
		width: @spacings[medium];
		flex-shrink: 0;
	}
	.CvSheet__tabSpacerAfter {
		//background-color: fade( green, 20 );
		//outline: 1px solid fade( green, 20 );
		
		border-bottom: 1px solid @tabsActiveBorderColor;
		width: 7em;		
		flex-shrink: 0;
	}
	.CvSheet__tabs {
		//outline: 1px solid fade(red, 15);
		position: relative;
		flex-grow: 1;		
		overflow: hidden;
		user-select: none;
		
		&::before {
			position: absolute;
			bottom: 0;
			left: 0; right: 0;
			border-bottom: 1px solid @tabsActiveBorderColor;
			content: "";
		}
	}
	.CvSheet__tabsTrack {
		display: flex;
		transition: all 0.2s ease;
		//overflow: hidden;
	}
	.CvSheet__tab {
		position: relative;
		width: calc( ( 100% - 0em ) / 10 + 1px );		
		margin-right: -1px;
		display: flex;
		flex-shrink: 0;
		flex-grow: 0;
		padding-bottom: 0.5em;
		
		transition: all 0.1s ease;		
		border-top-left-radius: 0.25em;
		border-top-right-radius: 0.25em;
		//text-align: center;
		user-select: none;
		color: inherit;
		
		border-top   : 1px solid @tabsInActiveBorderColor;
		border-left  : 1px solid @tabsInActiveBorderColor;
		border-right : 1px solid @tabsInActiveBorderColor;
		border-bottom: 1px solid @tabsActiveBorderColor;
		
		// last tab in the row
		&:nth-child(10n) {
			//border-left: none;
			margin-left: -1px;
			z-index: 1;
		}
		&:nth-child(10n) + & {
			margin-left: 1px;
		}
		
		&Label {
			padding: 0.5em;
			display: block;
			flex-grow: 1;
			
			transition: all 0.1s ease;
			line-height: 1em;
			color: @tabsInActiveBorderColor;
		}
		&--isActive &Label { 
			color: @tabsActiveBorderColor;			
		}
		&:hover &Label { 
			opacity: 1; 
		}
		
		&RemoveBtn {
			//background-color: fade( red, 20 );
			
			position: relative;
			padding: 0.5em;
			padding-right: 0.75em;
			line-height: 1em;
			
			transition: all 0.1s ease;
			opacity: 0;
			
			// circle
			&::before { 
				position: absolute;
				top: calc( 50% - 0.47em); 
				left: calc( 50% - 0.6em);
				//transform: translateY(-50%);
				
				transition: inherit;
				height: 1em; width: 1em;
				background-color: @swatches[blue];
				content: "";
				border-radius: 50%;
				opacity: 0;
			}
			&:hover&::before {
				opacity: 1;
			}
			// ×
			&::after { 
				position: relative;
				transition: inherit;
				content : "×"; 
				//color: white;
			}
			&:hover&::after {
				color: white;
			}
		}
		&:hover &RemoveBtn,
		&--isActive &RemoveBtn {
			opacity: 1;			
		}
		
		&--isInactive {
			background-color: darken( white, 5 );
			
			&:hover {
				background-color: white;				
			}
		}
		&--isActive { 
			background-color: white;
			border-color: @tabsActiveBorderColor;
			border-bottom: 1px solid transparent; 
			z-index: 2;
		}
		&--isHidden {
			display: none;
		}
		
		&--isInvalid &Label {
			font-weight: bold;
			color: red;
		}
		&--isInvalid { // red dot
			XXX&::after {
				position: absolute;
				top: 50%; right: 15%;
				height: 0.4em;
				width: 0.4em;
				transform: translateY(-50%);
				
				border-radius: 50%;
				background-color: @swatches[darkRed];
				content: "";
			}
		}
	}
	/*
	.CvSheet__tabSpacer {
		background-color: fade( red, 20 );
		
		flex-grow: 1;
		border-bottom: 1px solid @tabsActiveBorderColor;
		display: none;
	}
	*/
	.CvSheet__tabsNav {
		//background-color: fade( red, 20 );
		
		@btn : {
			width: 25px;
		}
		
		position: absolute;
		top: 0; right: @spacings[medium];
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 1em;
		transition: all 0.1s ease;
		font-size: 0.65em;
		line-height: 1em;
		
		&Btn {
			position: relative;
			width: @btn[width]; height: @btn[width];
			display: inline-flex;
			justify-content: center;
			align-items: center;
			
			transition: inherit;
			border: 1px solid @tabsActiveBorderColor;
			background-color: white;
			user-select: none;
			color: inherit;
		}
		&Btn:first-child {
			//margin-right: -1px;
		}
		&Btn--isDisabled {
			opacity: 0.75;
			color: @tabsInActiveBorderColor;
			pointer-events: none;
			border-color: currentColor;
			background-color: transparent;
		}
		
		&Btn--appendTab {
			//background-color: transparent;
			//border-color: transparent;
			margin-right: 0.75em;
			font-size: 2em;
			
			&&::after {
				position: absolute;
				top: 20%; left: 20%;
				content: "+";
			}
					
		}
	}
	
	.CvSheet__body {		
		padding-bottom: 0 !important;
	}
	
	.CvSheet__datasetRow {
		//& > * { outline: 1px solid fade(red, 25); }
		
		display: flex;
		border-bottom: 1px solid @swatches[middleGrey];
		padding-bottom: 1em;
		
		&--isHidden {
			display: none;
		}
		&--isInvalid {
			background-color: @swatches[lightRed];
			border-top: 1px solid @swatches[darkRed];		
			border-bottom: 1px solid @swatches[darkRed];
			margin-top: -1px;		
		}
		
		&Left { width: 60%; padding-right: 0.5em; flex-shrink: 0; }
		&Right { flex-grow: 1; padding-left: 0.5em; }
		/*
		&Label {
			padding-bottom: 0.5em;
			line-height: 1em;
			opacity: 0.75;
		}
		*/
		&--isInvalid .CvSheet__datasetLabel {
			.font--bold;
			color: @swatches[darkRed];
			//color: green;
		}
	}
	
	.CvSheet__errorMsg {
		&Title {
			padding-bottom: 0.5em;
			line-height: 1em;
		}
		&Text {}
	}
	
	
	
	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
